import { Inputfiledsbase } from './models/inputfiledsbase';

export class TextareaQuestion extends Inputfiledsbase<string> {
  override controlType = 'textarea';
}